import React from "react";
import { StaticQuery, graphql, Link } from "gatsby"

export default () => {

        return (
            <div className="tagBox">
                <StaticQuery
                    query={graphql`
                    query {
                        allMarkdownRemark(
                            filter: {fileAbsolutePath: {regex: "/tags/"}},
                            sort:{order: DESC, fields: score},
                            limit:20
                            ) {
                            totalCount
                            edges {
                                node {
                                  frontmatter {
                                    name
                                    label
                                  }
                                }
                          
                            }
                        }
                    }
                    `}
                    render={
                        data => {
                            return data.allMarkdownRemark.edges.map((elem, id) => {

                                return (<><span
                                    key={id}
                                    style={{
                                    textTransform: 'uppercase',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap'
                                }}><Link style={{textDecoration: 'none', color: 'hsla(0, 0%, 0%, 0.8)'}} to={'/tag/' + elem.node.frontmatter.name}>{ elem.node.frontmatter.label }</Link></span> </>);
                            });
                        }
                    }
                />
            </div>
        );
}